/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import get from 'lodash/fp/get.js';
import getOr from 'lodash/fp/getOr.js';
import { modelsUniqueProjects } from '#selectors/entities/models.js';
import { selectFieldAiStatus } from '#selectors/entities/modelAiReview.js';
import ProjectSelector from './ProjectSelector.jsx';

const mapStateToProps = (state, ownProps) => {
  const projects = modelsUniqueProjects(state);

  // Compute the field's AI-review status exactly as the shared ModelFormField does (its index.js),
  // so ProjectSelector's decision to delegate to ModelFormField matches what ModelFormField would
  // itself render (#154). PROJECT_NAME has no array item, so the field name is fully qualified.
  const { field } = ownProps;
  const { name, form } = field || {};
  const visible = !!get(name, getOr({}, `form[${form}].visibleFields`, state));
  const aiStatus = visible && form ? selectFieldAiStatus(form, name)(state) : 'none';

  return {
    projects,
    aiStatus,
  };
};

export default connect(mapStateToProps)(ProjectSelector);
